import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

import { computed, ComputedRef, toRefs } from 'vue';

interface PropsInterface {
  initials?: string;
  size?: number;
  fontSize?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Initials',
  props: {
    initials: { default: 'N/A' },
    size: { default: 25 },
    fontSize: { default: 10 }
  },
  setup(__props: any) {

const props = __props;

const { initials, size, fontSize } = toRefs(props);

const sizeToWidthAndHeight: ComputedRef = computed(
  () => `font-size: ${fontSize.value}px; height:${size.value}px; width:${size.value}px`,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle(sizeToWidthAndHeight.value),
    class: "user-button text-white inline-flex border-none relative align-items-center justify-content-center cursor border-circle font-bold",
    textContent: _toDisplayString(_unref(initials))
  }, null, 12, _hoisted_1))
}
}

})